module.exports = __webpack_public_path__ + "static/media/refer-a-friend.544c2f34.svg";